import members from "./members";
import readings from "./readings";
import coordinator from "./coordinator";
import notifications from "./notifications";
import devices from "./devices";
import configurations from "./configurations";
import orders from "./orders";
import encounters from "./encounters";
import notes from "./notes";
import archived from "./archived";
import settings from "./settings";

export const host = window.location.hostname.split(".");

let mel: any;
let kore: any;
let socket: any;
let sinope: any;

if (process.env.REACT_APP_NODE_ENV === "development") {
  mel = process.env.REACT_APP_MEL_URL;
  kore = process.env.REACT_APP_KORE_URL;
  socket = process.env.REACT_APP_SOCKET_URL;
  sinope = process.env.REACT_APP_SINOPE_URL;
} else {
  // Mel can point to a production sandbox for a specific client if they have requested a
  // sandbox evironment with its own configurations.
  const isProdSBX = host[1] !== "sbx" ? [host[2], host[3]] : ["life365",`tools`];
  mel = `https://security.${host[1]}.${isProdSBX[0]}.${isProdSBX[1]}`;
  kore = `https://${host[0]}.${host[1]}.${host[2]}.${host[3]}`;
  socket = `https://${host[0]}.${host[1]}.${host[2]}.${host[3]}`;
  sinope = `https://dbx.${host[1]}.${host[2]}.${host[3]}`;
}

export const mel_url = mel;
export const kore_url = kore;
export const socket_url = socket;
export const sinope_url = sinope;

export default {
  coordinator,
  readings,
  members,
  notifications,
  kore_url,
  devices,
  configurations,
  orders,
  encounters,
  notes,
  archived,
  settings,
};
